import { useEffect, useState } from 'react'

import { getStoreImages } from './helpers'

const useThemeImages = storeTheme => {
  const [images, setImages] = useState(getStoreImages(storeTheme))
  const [hasImageChanges, setHasImageChanges] = useState(false)

  useEffect(() => {
    setImages(getStoreImages(storeTheme))
  }, [storeTheme])

  const deleteImage = imageKey => {
    setImages(prev => ({
      ...prev,
      [imageKey]: {
        ...prev[imageKey],
        preview: null,
        file: new File([], ''),
      },
    }))
    setHasImageChanges(true)
  }

  const changeImage = (imageKey, file) => {
    const reader = new FileReader()
    reader.onload = () => {
      setImages(prev => ({
        ...prev,
        [imageKey]: {
          ...prev[imageKey],
          file,
          preview: reader.result,
        },
      }))
      setHasImageChanges(true)
    }
    reader.readAsDataURL(file)
  }

  const changeLink = (imageKey, url) => {
    setImages(prev => ({
      ...prev,
      [imageKey]: {
        ...prev[imageKey],
        link: {
          ...prev[imageKey].link,
          url,
        },
      },
    }))
    setHasImageChanges(true)
  }

  const newThemeImages = () => {
    const newThemeImages = {}

    Object.entries(images).forEach(([key, { file, link }]) => {
      newThemeImages[key] = { file, link }
    })

    return newThemeImages
  }

  const revertImageChanges = () => {
    setImages(getStoreImages(storeTheme))
    setHasImageChanges(false)
  }

  return {
    images,
    deleteImage,
    changeImage,
    newThemeImages,
    hasImageChanges,
    setHasImageChanges,
    revertImageChanges,
    changeLink,
  }
}

export default useThemeImages
